export default __webpack_public_path__ + "static/banner_washington-2d58a86aea1316269638c729c8279ae1.webp";